@if (canShow) {
  @if (showLabel) {
    <button
      mat-menu-item
      (click)="onGenerate()"
      [disabled]="selectedProducts.length === 0"
      >
      <mat-icon>data_object</mat-icon>
      <span>Create Product Labels</span>
    </button>
  }
  @if (!showLabel) {
    <button
      mat-icon-button
      class="apply-enhancement"
      matTooltip="Create Product Labels"
      (click)="onGenerate()"
      [disabled]="selectedProducts.length === 0"
      >
      <mat-icon>data_object</mat-icon>
    </button>
  }
}
